import { useState, useEffect } from 'react'

interface Props {
  photoURL: string | null | undefined
  displayName?: string | null
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

const SIZE = {
  sm: 'w-8 h-8 text-xs',
  md: 'w-10 h-10 text-sm',
  lg: 'w-12 h-12 text-lg',
}

export function UserAvatar({ photoURL, displayName, size = 'md', className = '' }: Props) {
  const [error, setError] = useState(false)

  useEffect(() => { setError(false) }, [photoURL])

  const base = `${SIZE[size]} rounded-full flex-shrink-0 ${className}`

  if (photoURL && !error) {
    return (
      <img
        src={photoURL}
        alt={displayName ?? ''}
        referrerPolicy="no-referrer-when-downgrade"
        onError={() => setError(true)}
        className={`${base} object-cover`}
      />
    )
  }

  return (
    <div className={`${base} bg-beacon-100 flex items-center justify-center`}>
      <i className="fa-solid fa-user text-beacon-300" style={{ fontSize: '45%' }} />
    </div>
  )
}
